export default "__VITE_ASSET__CMkxdRo7__"